import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface AuthPageLayoutProps {
  children: ReactNode;
  hasBeenInteracted: boolean;
}

/**
 * Shared layout component for authentication pages (Login, OTP, Forgot Password)
 * Provides consistent background, logo positioning, and responsive behavior
 */
export function AuthPageLayout({ children, hasBeenInteracted }: AuthPageLayoutProps) {
  return (
    <div className="h-screen bg-dark">
      <div className="max-w-md md:max-w-none lg:max-w-none xl:max-w-md mx-auto h-full">
        <div
          className={cn(
            "flex h-full w-full bg-[url('/images/login/login-bg.webp')] bg-contain bg-top bg-no-repeat md:bg-[length:70%] md:bg-center md:bg-no-repeat lg:bg-[length:70%] lg:bg-center lg:bg-no-repeat xl:bg-contain xl:bg-top xl:bg-no-repeat relative",
            hasBeenInteracted
              ? "flex-col pt-0 md:flex-row md:items-center md:justify-center md:pt-0 lg:flex-row lg:items-center lg:justify-center lg:pt-0 xl:flex-row xl:items-center xl:justify-center xl:pt-0"
              : "items-center justify-center"
          )}
        >
          <img
            src="/images/logo_white.svg"
            alt="Mezza Logo"
            className="absolute top-4 left-1/2 -translate-x-1/2 md:top-8 md:left-auto md:right-auto md:translate-x-0 object-cover w-32 h-auto"
          />
          <div
            className={cn(
              "w-full overflow-y-auto container bg-background mx-auto transition-all duration-300 ease-in-out flex flex-col",
              hasBeenInteracted
                ? "pt-4 pb-0 h-full md:h-[100%] lg:h-[65%] md:pt-8 md:pb-4 lg:pt-8 lg:pb-4 xl:pt-8 xl:pb-4 md:self-end lg:self-end xl:self-end overflow-y-auto rounded-none"
                : "self-end pt-8 h-[60%] md:h-[55%] lg:h-[55%] xl:h-[50%] rounded-t-xl"
            )}
          >
            <div className="w-full md:max-w-md md:mx-auto flex flex-col space-y-6">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
